import { Outlet, Navigate } from 'react-router-dom';
import { HOME } from './paths';
import { useAuthContext } from '../contexts/authContext';
import { LayoutDefault } from '../components/layout/default/layoutDefault';
import { LayoutIcetex } from '../components/layout/icetex/layoutIcetex';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import React, { useEffect, useState } from 'react';
import BlockPagesIcetex from '../components/components/views/blockPagesIcetex';

type Props = {
    viewIcetex?: false | boolean;
    blockPageName?: string;
};

export default function PublicRoute({ viewIcetex, blockPageName }: Props) {
    const { tokenAuth } = useAuthContext();
    const { blockPagesList } = useSelector((state: RootState) => state.general);
    const [checkValidate, setCheckValidate] = useState<boolean>(false);
    const [validate, setValidate] = useState<any>(undefined);

    useEffect(() => {
        if (blockPagesList.length > 0) {
            const validate =
                blockPagesList.find((row: any) => row.page === blockPageName) ||
                undefined;
            setCheckValidate(validate !== undefined);
            setValidate(validate);
        }
    }, [blockPageName, blockPagesList]);

    if (tokenAuth) {
        return <Navigate to={HOME} />;
    }

    return !viewIcetex ? (
        <LayoutDefault>
            {checkValidate ? (
                <BlockPagesIcetex validate={validate} />
            ) : (
                <Outlet />
            )}
        </LayoutDefault>
    ) : (
        <LayoutIcetex>
            {checkValidate ? (
                <BlockPagesIcetex validate={validate} />
            ) : (
                <Outlet />
            )}
        </LayoutIcetex>
    );
}
